(() => {
  const cartUrl = window.routes?.cart_url || '/cart';
  const rootUrl = window.routes?.root_url || '/';
  const convocationPath = '/collections/mcgill-convocation-flowers';
  const cartContextKey = 'mmp-cart-return-context';

  const clean = (path) => String(path || '/').replace(/\/+$/, '') || '/';
  const isCart = () => clean(window.location.pathname) === clean(new URL(cartUrl, window.location.origin).pathname);
  const isConvocationPage = () =>
    clean(window.location.pathname) === clean(convocationPath) ||
    !!document.querySelector('input[name="properties[_mmp_order_group]"][value="mcgill-convocation"]') ||
    !!document.querySelector('select[name="properties[Convocation Date]"], select[name="properties[Convocation Time]"]');

  const targetWithPreview = (path) => {
    const url = new URL(path, window.location.origin);
    const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return `${url.pathname}${url.search}`;
  };

  const homeTarget = () => targetWithPreview(rootUrl);
  const convocationTarget = () => targetWithPreview(convocationPath);

  const rememberConvocationContext = () => {
    try {
      window.sessionStorage.setItem(cartContextKey, 'convocation');
    } catch (error) {}
  };

  const clearConvocationContext = () => {
    try {
      window.sessionStorage.removeItem(cartContextKey);
    } catch (error) {}
  };

  const hasRememberedConvocationContext = () => {
    try {
      return window.sessionStorage.getItem(cartContextKey) === 'convocation';
    } catch (error) {
      return false;
    }
  };

  const cartIsEmpty = () => {
    if (!isCart()) return false;
    const cartItems = document.querySelector('cart-items');
    return !!cartItems?.classList.contains('is-empty');
  };

  const isHomeLink = (link) => {
    if (!link?.getAttribute) return false;
    const href = link.getAttribute('href');
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin && clean(url.pathname) === clean(new URL(rootUrl, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  };

  const cartHasConvocationItem = () => {
    if (!isCart()) return false;
    const cartItems = document.querySelector('cart-items');
    if (!cartItems || cartItems.classList.contains('is-empty')) return false;

    if (cartItems.querySelector('[data-mmp-order-group="mcgill-convocation"]')) return true;

    const convocationPropertyNames = new Set([
      'convocation date',
      'convocation time',
      'mcgill convocation pickup'
    ]);

    return Array.from(cartItems.querySelectorAll('.product-option dt')).some((term) => {
      const key = String(term.textContent || '')
        .trim()
        .replace(/:\s*$/, '')
        .toLowerCase();
      return convocationPropertyNames.has(key);
    });
  };

  const cartContinueTarget = () =>
    (cartHasConvocationItem() || (cartIsEmpty() && hasRememberedConvocationContext()))
      ? convocationTarget()
      : homeTarget();

  const ensureConvocationNoticeStyle = () => {
    if (document.getElementById('mmp-convocation-cart-style')) return;
    const style = document.createElement('style');
    style.id = 'mmp-convocation-cart-style';
    style.textContent = '#mmp-convocation-cart-notice{margin:0 0 2rem;padding:1.2rem 1.5rem;border:1px solid rgba(var(--color-foreground),.18);border-radius:.6rem;}#mmp-convocation-cart-notice p{margin:0;}';
    document.head.appendChild(style);
  };

  const isCartHomeLink = (link) =>
    isCart() && !!link?.closest?.('cart-items .title-wrapper, cart-items .cart__warnings');

  const applyCartContext = () => {
    if (!isCart()) return;

    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    const hasConvocationItem = cartHasConvocationItem();
    const isEmpty = cartItems.classList.contains('is-empty');

    if (hasConvocationItem) rememberConvocationContext();
    else if (!isEmpty) clearConvocationContext();

    const returnToConvocation = hasConvocationItem || (isEmpty && hasRememberedConvocationContext());
    const titleLink = cartItems.querySelector('.title-wrapper a[href]');
    const emptyCartLink = cartItems.querySelector('.cart__warnings a[href]');

    if (titleLink) {
      titleLink.setAttribute('href', returnToConvocation ? convocationTarget() : homeTarget());
      titleLink.textContent = returnToConvocation
        ? 'Back to McGill Convocation Flowers'
        : 'Continue shopping';
    }

    if (emptyCartLink) {
      emptyCartLink.setAttribute('href', returnToConvocation ? convocationTarget() : homeTarget());
      emptyCartLink.textContent = returnToConvocation
        ? 'Back to McGill Convocation Flowers'
        : 'Continue shopping';
    }

    let notice = document.getElementById('mmp-convocation-cart-notice');

    if (hasConvocationItem) {
      ensureConvocationNoticeStyle();

      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'mmp-convocation-cart-notice';
        notice.className = 'rte';
        notice.setAttribute('role', 'note');
        notice.innerHTML = '<p><strong>McGill Convocation order:</strong> Please add only Convocation products to this order. For regular flower orders, please place a separate order.</p>';
        cartItems.querySelector('.title-wrapper')?.insertAdjacentElement('afterend', notice);
      }
    } else if (notice) {
      notice.remove();
    }
  };

  const applyConvocationShell = () => {
    if (!isConvocationPage()) return;

    if (!document.getElementById('mcgill-convocation-shell-style')) {
      const style = document.createElement('style');
      style.id = 'mcgill-convocation-shell-style';
      style.textContent = '.header__inline-menu,.header__menu,.header__icon--menu,.header__icon--search,mobile-dock .dock__item[data-action="menu"],mobile-dock .dock__item[data-action="search"]{display:none!important;}';
      document.head.appendChild(style);
    }

    document.querySelectorAll('a[href]').forEach((link) => {
      if (!isHomeLink(link)) return;
      link.setAttribute('href', convocationTarget());
      const label = link.closest('mobile-dock')?.querySelector('span');
      if (label && label.textContent.trim().toLowerCase() === 'home') label.textContent = 'Convocation';
    });
  };

  if (window.shopSettings) window.shopSettings.cartDrawer = false;

  document.addEventListener('click', (event) => {
    const link = event.target?.closest?.('a[href]');

    if (link && isCartHomeLink(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(cartContinueTarget());
      return;
    }

    if (link && isConvocationPage() && isHomeLink(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(convocationTarget());
      return;
    }

    const cartTrigger = event.target?.closest?.('cart-drawer summary, .dock__item[data-action="cart"]');
    if (cartTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(cartUrl);
    }
  }, true);

  const prepare = () => {
    if (isConvocationPage()) rememberConvocationContext();
    else if (!isCart()) clearConvocationContext();

    document.querySelectorAll('.dock__item[data-action="cart"]').forEach((el) => {
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
    });
    document.querySelectorAll('cart-drawer details[open]').forEach((details) => details.removeAttribute('open'));
    applyCartContext();
    applyConvocationShell();

    if (isCart()) {
      let timer;
      const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(applyCartContext, 50);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  document.addEventListener('keydown', (event) => {
    const cartTrigger = event.target?.closest?.('.dock__item[data-action="cart"]');
    if (!cartTrigger || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(cartUrl);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
})();

(() => {
  const clean = (path) => String(path || '/').replace(/\/+$/, '') || '/';
  const cartPath = clean(new URL(window.routes?.cart_url || '/cart', window.location.origin).pathname);
  const onCartPage = () => clean(window.location.pathname) === cartPath;

  const patchCartItems = () => {
    const CartItems = window.customElements?.get('cart-items');
    if (!CartItems || CartItems.prototype.__mmpCartSectionFix) return !!CartItems;

    const originalGetSectionsToRender = CartItems.prototype.getSectionsToRender;
    if (typeof originalGetSectionsToRender !== 'function') return false;

    CartItems.prototype.getSectionsToRender = function() {
      const sections = originalGetSectionsToRender.call(this) || [];
      const seen = new Set();

      return sections.filter((section) => {
        if (!section?.section) return false;
        if (onCartPage() && section.id === 'mini-cart') return false;
        if (seen.has(section.section)) return false;
        seen.add(section.section);
        return true;
      });
    };

    CartItems.prototype.__mmpCartSectionFix = true;
    return true;
  };

  if (!patchCartItems()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (patchCartItems() || attempts >= 50) window.clearInterval(timer);
    }, 100);
  }
})();

(() => {
  const convocationPropertyNames = new Set([
    'convocation date',
    'convocation time',
    'mcgill convocation pickup'
  ]);

  const hasConvocationItem = (cartItems) => {
    if (cartItems?.querySelector?.('[data-mmp-order-group="mcgill-convocation"]')) return true;

    return Array.from(cartItems?.querySelectorAll?.('.product-option dt') || []).some((term) => {
      const key = String(term.textContent || '')
        .trim()
        .replace(/:\s*$/, '')
        .toLowerCase();
      return convocationPropertyNames.has(key);
    });
  };

  const patchConvocationQuantity = () => {
    const CartItems = window.customElements?.get('cart-items');
    if (!CartItems || CartItems.prototype.__mmpConvocationQuantityFix) return !!CartItems;

    const originalUpdateQuantity = CartItems.prototype.updateQuantity;
    if (typeof originalUpdateQuantity !== 'function') return false;

    CartItems.prototype.updateQuantity = function(line, quantity, name) {
      if (!hasConvocationItem(this)) {
        return originalUpdateQuantity.call(this, line, quantity, name);
      }

      const input = this.querySelector(`#Quantity-${line}`);
      const previousValue = input?.getAttribute('value') || input?.defaultValue || input?.value;
      const errorContainer = document.getElementById('cart-errors');

      if (typeof this.enableLoading === 'function') this.enableLoading(line);

      return window.fetch(window.routes?.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity)
        })
      })
        .then(async (response) => {
          const data = await response.json().catch(() => ({}));
          const errorMessage = typeof data?.errors === 'string'
            ? data.errors
            : (data?.description || data?.message || 'Unable to update cart quantity.');

          if (!response.ok || data?.status || data?.errors) {
            throw new Error(errorMessage);
          }

          window.location.reload();
        })
        .catch((error) => {
          if (input && previousValue != null) input.value = previousValue;
          if (errorContainer) errorContainer.textContent = error?.message || 'Unable to update cart quantity.';
          if (typeof this.disableLoading === 'function') this.disableLoading();
        });
    };

    CartItems.prototype.__mmpConvocationQuantityFix = true;
    return true;
  };

  if (!patchConvocationQuantity()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (patchConvocationQuantity() || attempts >= 50) window.clearInterval(timer);
    }, 100);
  }
})();

(() => {
  if (window.__mmpConvocationQuantityClickFix) return;
  window.__mmpConvocationQuantityClickFix = true;

  const clean = (path) => String(path || '/').replace(/\/+$/, '') || '/';
  const cartPath = clean(new URL(window.routes?.cart_url || '/cart', window.location.origin).pathname);
  const isCart = () => clean(window.location.pathname) === cartPath;

  const convocationPropertyNames = new Set([
    'convocation date',
    'convocation time',
    'mcgill convocation pickup'
  ]);

  const cartHasConvocationItem = () => {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems || cartItems.classList.contains('is-empty')) return false;

    if (cartItems.querySelector('[data-mmp-order-group="mcgill-convocation"]')) return true;

    return Array.from(cartItems.querySelectorAll('.product-option dt')).some((term) => {
      const key = String(term.textContent || '')
        .trim()
        .replace(/:\s*$/, '')
        .toLowerCase();
      return convocationPropertyNames.has(key);
    });
  };

  let updating = false;

  const updateLine = async (input, quantity) => {
    if (updating || !input) return;

    const line = Number(input.dataset.index);
    if (!Number.isFinite(line) || line < 1) return;

    const nextQuantity = Math.max(0, Number(quantity) || 0);
    const errorContainer = document.getElementById('cart-errors');
    const quantityInput = input.closest('quantity-input');

    updating = true;
    quantityInput?.querySelectorAll('button, input').forEach((el) => {
      el.disabled = true;
    });

    try {
      const response = await window.fetch(window.routes?.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line,
          quantity: nextQuantity
        })
      });

      const data = await response.json().catch(() => ({}));
      const errorMessage = typeof data?.errors === 'string'
        ? data.errors
        : (data?.description || data?.message || 'Unable to update cart quantity.');

      if (!response.ok || data?.status || data?.errors) {
        throw new Error(errorMessage);
      }

      window.location.reload();
    } catch (error) {
      updating = false;
      quantityInput?.querySelectorAll('button, input').forEach((el) => {
        el.disabled = false;
      });
      if (errorContainer) {
        errorContainer.textContent = error?.message || 'Unable to update cart quantity.';
      }
    }
  };

  document.addEventListener('click', (event) => {
    if (!isCart() || !cartHasConvocationItem()) return;

    const button = event.target?.closest?.(
      'cart-items quantity-input button[name="plus"], cart-items quantity-input button[name="minus"]'
    );
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (updating) return;

    const input = button.closest('quantity-input')?.querySelector('input[name="updates[]"]');
    if (!input) return;

    const current = Number(input.value) || 0;
    const step = Math.max(1, Number(input.step) || 1);
    const minValue = input.min === '' ? 0 : Number(input.min);
    const min = Number.isFinite(minValue) ? minValue : 0;
    const maxValue = input.max === '' ? Infinity : Number(input.max);
    const max = Number.isFinite(maxValue) ? maxValue : Infinity;

    const desired = button.name === 'plus'
      ? Math.min(max, current + step)
      : Math.max(min, current - step);

    if (desired === current) return;

    input.value = desired;
    updateLine(input, desired);
  }, true);

  document.addEventListener('change', (event) => {
    if (!isCart() || !cartHasConvocationItem()) return;

    const input = event.target?.closest?.('cart-items input[name="updates[]"]');
    if (!input || updating) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    updateLine(input, input.value);
  }, true);
})();
